import { render } from "./DeliveryAddress.vue?vue&type=template&id=0c3b4412&ts=true"
import script from "./DeliveryAddress.vue?vue&type=script&lang=ts"
export * from "./DeliveryAddress.vue?vue&type=script&lang=ts"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__